import { BusinessRuleOutcome, BusinessRulePredicate } from '../model';

export function validateRuleStatus(
  predicates?: Partial<BusinessRulePredicate>[],
  outcomes?: Partial<BusinessRuleOutcome>[]
) {
  const predicateInvalid = validateRulePredicates(predicates);
  const outcomeInvalid = validateRuleOutcomes(outcomes);

  return predicateInvalid || outcomeInvalid ? 'Warning' : '';
}

export function validateRuleOutcomes(
  outcomes?: Partial<BusinessRuleOutcome>[]
) {
  return outcomes?.some(
    (x) =>
      checkValidity(x.updateValue) && x.updateTypeResourceId !== 'DeleteUser'
  );
}

export function validateRulePredicates(
  predicates?: Partial<BusinessRulePredicate>[]
) {
  return predicates?.some((x) => checkValidity(x.comparisonValue));
}

function checkValidity(value) {
  return value === null || value === undefined || value === '';
}
